export default __webpack_public_path__ + "static/Portfolio-dce0313f42953a2ee2e5c9a4733a37c3.png";